import { Typography } from "antd";
import "./typography.scss"
export default Typography;
